import type { FeeOfferingType } from "app/shared/model/EditPricelist";

export const normalizeFeeOfferingType = (t: any): FeeOfferingType => {
    const s = String(t ?? "").trim().toLowerCase();
    return s === "supplement" ? "Supplement" : "One Off";
};
